import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import '../index.css';
import Navbar from '../components/Navbar';
import FormValueProvider from '../services/FormValueProvider';
import TemplateInputForm from '../components/TemplateInputForm';

function TemplateEditPage() {
  const { template_id } = useParams();
  useEffect(() => {
  }, [template_id]);

  return (
    <div>
      <Navbar></Navbar>
      <FormValueProvider>
        <h2>Edit Template</h2>
        <TemplateInputForm template_id={template_id} templateStatus="templateEdit"></TemplateInputForm>
      </FormValueProvider>
    </div>
  );
}

export default TemplateEditPage;